import React, { createContext, FC, useContext } from "react";
import { BookingFilterValuesDto } from "../../../../Api/Model/BookingFilterValuesDto.csharp";
import { WaitlistViewModel } from "../../../Blocks/Waitlist/WaitlistViewModel.csharp";
import { NewBookingFilterValuesDto } from "@apiModels/NewBookingFilterValuesDto.csharp";
import { OptimizelyExperimentation } from "../OptimizelyExperimentation.csharp";

type ContextProps = {
  dipsAutoQueryMaxRepeats: number;
  requireParentSsn: boolean;
  filterValues?: BookingFilterValuesDto;
  newBookingFilterValues?: NewBookingFilterValuesDto;
  waitlist?: WaitlistViewModel;
  optimizelyExperimentation?: OptimizelyExperimentation;
  trackAbEvent?: boolean;
  awaitTime?: string;
  blockedSsnList: string[];
  blockedSsnErrorMessage: string;
};

export const BookingContext = createContext<ContextProps>({
  dipsAutoQueryMaxRepeats: 0,
  requireParentSsn: false,
  blockedSsnList: [],
  blockedSsnErrorMessage: "",
});

export const BookingProvider: FC<ContextProps> = (props) => {
  return (
    <BookingContext.Provider value={props}>
      {props.children}
    </BookingContext.Provider>
  );
};

export const useBookingContext = () => useContext(BookingContext);
